export default __webpack_public_path__ + "static/media/close.9ef32ecd.svg";